<template>
    <div class="mds-masthead__inner language-selector">
        <div class="mds-masthead__right">
            <a v-on:click="changeLanguage('en')">EN</a>
            <a v-on:click="changeLanguage('sp')">SP</a>
        </div>
    </div>
</template>

<script>

    export default {

        name: "languageChanger",
        mounted () {
            this.changeLanguage(this.$i18n ? this.$i18n.i18next.language : this.defaultLng);
        },
        data () {
            return {
                lng: ""
            };
        },
        methods: {
            changeLanguage (lng) {
                this.$i18n.i18next.changeLanguage(lng);
                this.lng = lng;
                const languageSelectors = this.$el.children[0].children;
                for (let ndx = 0; ndx < languageSelectors.length; ndx++) {
                    if ((languageSelectors[ndx].innerText.toLowerCase()) === lng) {
                        languageSelectors[ndx].className = "current-language";
                    } else {
                        languageSelectors[ndx].className = "";
                    }
                }
            }
        }
    };

</script>

<style lang="scss" scoped>

    .language-selector a {
        cursor: pointer;
    }

    .language-selector a.current-language {
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/LanguageChanger.vue